<script setup>
import fengsui2Img from '../../../../assets/images/fengsui2.webp';
</script>

<template>
  <section class="hall-section">
    <div class="image-container">
      <img
        :src="fengsui2Img"
        alt="楓燧堂"
        class="hall-image"
      />
    </div>
    <div class="text-container">
      <h2 class="title">楓燧堂</h2>
      <p class="paragraph">
        楓燧堂秉承中華優秀傳統文化，以「傳道、弘道」為使命，致力於推廣國學教育與文化實踐。我們的宗旨包括：
      </p>
      <ul class="objectives-list">
        <li>弘揚儒釋道三家智慧，普及中華傳統生活科學；</li>
        <li>傳承中華哲學精神，促進社會融合與文化自信；</li>
        <li>組織各類傳統文化活動，實踐道法自然的生活理念。</li>
      </ul>

      <p class="paragraph">
        在弘揚國學的道路上，楓燧堂關注海內外國民的身心靈成長，堅持「信、德、仁、勇」的核心價值，融合公益理念，積極履行企業社會責任。我們立志成為一家具備社會價值、人民信賴、國家認可的文化服務機構。
      </p>
    </div>
  </section>
</template>

<style scoped lang="scss">
.hall-section {
  width: 100%;
  padding: 0.2rem 0.4rem;
  background: #ffffff;
}

.image-container {
  width: 100%;
  margin-bottom: 0.5rem;

  .hall-image {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
  }
}

.text-container {
  .title {
    font-size: 1rem;
    color: #333333;
    margin-bottom: 0.5rem;
    line-height: 1.4;
    text-align: center;
  }

  .paragraph {
    font-size: 0.48rem;
    color: rgb(80, 85, 92);
    line-height: 1.5;
    // margin-bottom: 0.5rem;
    // text-align: center;

    &:last-of-type {
      margin-bottom: 0.7rem;
    }
  }

  .objectives-list {
    list-style-type: decimal;
    padding-left: 0.5rem;
    margin: 0.1rem 0 0.5rem;

    li {
      font-size: 0.48rem;
      color: rgb(80, 85, 92);
      line-height: 1.5;
      margin-bottom: 0.2rem;
      // text-align: center;
    }
  }
}
</style>
